export default __webpack_public_path__ + "static/media/uberDirectLogo.a8a7cf65.png";